// extracted by mini-css-extract-plugin
export default {"list":"time-tracking-overview_list__h0+ke","list__title":"time-tracking-overview_list__title__w3M0-"};